import { useState } from "react";

import FilterPopup from "../../popup/filterPopup";
import SearchBar from "../../reusebale/searchBar";
import LeasesTable from "../leases/leaseTable";
import DetailMain from "../maintenance/maintanance-detail/detailMain";
import CreateMain from "./createProperty/createMain";
import DetailLeaseMain from "./leaseDetail/main";

import db from "../../../db/index.json";

import { useDispatch } from "react-redux";
import * as LeaseDataAction from "../../../store/actions/lease/LeaseAction";

const LeasesSection = ({
  toggleMaintainanceTable,
  onTriggerCard,
  onTennantTable,
}) => {
  const { lease } = db;
  const [showFilter, setShowFilter] = useState(false);
  const [showTable, setShowTable] = useState("table");
  const [showDetail, setShowDetail] = useState("");
  const [recordId, setRecordId] = useState();
  const [recordMainId, setRecordMainId] = useState();
  const dispatch = useDispatch();
  const toggleDetailMaintain = () => {
    setShowTable("MaintainanceDetails");
  };

  const openPopup = () => {
    setShowFilter(true);
  };

  const closePopup = () => {
    setShowFilter(false);
  };

  const toggleDetail = (status, id) => {
    setShowDetail(status);
    setRecordId(id);
    localStorage.setItem("leaseid", id);
    localStorage.setItem("leasestatus", status);
    setShowTable("detail"); // State toggle karein
  };

  const toggleDetailLease = () => {
    const id = localStorage.getItem("leaseid");
    const status = localStorage.getItem("leasestatus");
    setRecordId(id);
    setShowDetail(status);
    setShowTable("detail");
  };

  const toggleCreate = () => {
    setShowTable("create");
  };

  const toggleCreateNewLease = () => {
    // Clear any renewal mode when creating new lease
    dispatch(LeaseDataAction.ClearLeaseRenewalModeAction());
    setShowTable("create");
  };

  const toggleTable = () => {
    setShowTable("table");
  };

  const [search, setSearch] = useState("");
  const [status, setStatus] = useState("all");
  return (
    <div>
      {(() => {
        switch (showTable) {
          case "table":
            return (
              <div>
                <div className="h-[10vh]">
                  <SearchBar
                    filterShow={true}
                    value={search}
                    onSearchChange={(e) => {
                      setSearch(e.target.value);
                    }}
                    title={lease.title}
                    desc={lease.description}
                    onSubmit={openPopup}
                  />
                </div>
                <div className="h-[90vh]">
                  <LeasesTable
                    status={status}
                    search={search}
                    isViewDetails={toggleDetail}
                    onViewCreate={toggleCreate}
                  />
                </div>
              </div>
            );
          case "detail":
            return (
              <DetailLeaseMain
                onBack={toggleTable}
                onEditLease={(leaseDetails) => {
                  toggleCreateNewLease(); // Use the new function that clears renewal mode
                  dispatch(LeaseDataAction.LeaseDetailAction(leaseDetails));
                }}
                showDetailStatus={showDetail}
                recordId={recordId}
                onViewDetailsMaintain={(item) => {
                  setRecordMainId(item);
                  toggleDetailMaintain(item);
                }}
                onMaintainancePage={toggleMaintainanceTable}
                onTriggerCard={onTriggerCard}
                toggleTenantTable={onTennantTable}
              />
            );
          case "create":
            return <CreateMain onBack={toggleTable} />;
          case "MaintainanceDetails":
            return (
              <DetailMain
                recordId={recordMainId._id}
                onBack={toggleDetailLease}
              />
            );
          default:
            break;
        }
      })()}
      {showFilter && (
        <FilterPopup
          onBack={closePopup}
          onFilter={(propertyNamse, Statuss) => {
            setSearch(propertyNamse);
            setStatus(Statuss);
            closePopup();
          }}
        />
      )}
    </div>
  );
};

export default LeasesSection;
